export default "__VITE_ASSET__e2e60f38__"